import {defineStore} from 'pinia';

export const useThemeStore = defineStore('themeStore', {
    state: () => ({
        isDark: true,
    }),
    actions: {
        toggleTheme() {
            this.isDark = !this.isDark;
            document.documentElement.classList.toggle('dark', this.isDark);
            localStorage.setItem('theme', this.isDark ? 'dark' : 'light');
        },
        loadTheme() {
            if (!localStorage.getItem('theme')) {
                localStorage.setItem('theme', this.isDark ? 'dark' : 'light');
            }

            this.isDark = localStorage.getItem('theme') === 'dark';
            document.documentElement.classList.toggle('dark', this.isDark);
        }
    }
});
